import { render, staticRenderFns } from "./deliveryOrderSum.vue?vue&type=template&id=f55a70b4&scoped=true&"
import script from "./deliveryOrderSum.vue?vue&type=script&lang=js&"
export * from "./deliveryOrderSum.vue?vue&type=script&lang=js&"
import style0 from "./deliveryOrderSum.vue?vue&type=style&index=0&id=f55a70b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55a70b4",
  null
  
)

export default component.exports